import React from 'react';
import { navigate } from '@reach/router';
import { PureComponent } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { fetchEmptyCounts } from './fetchEmptyCounts';
import MyModal from 'components/Modal';

import {
  BedContainer,
  Container,
  Descriptoin,
  DownContainer,
  ICUContainer,
  ImageColumn,
  ImageComponent,
  ImageContainer,
  ImageRow,
  ImageSection,
  ItemTitle,
  ItemValue,
  Row,
  TableHead,
  TableHeaderRow,
  TableHeaderTitle,
  TableHeaderTitleValue,
  TableItemSubTitle,
  TableItemTitle,
  TableItemValue,
  TableRow,
  TableWrapper,
} from './styles';
import Button from '../components/Button/Button';
import messages from './messages';
import Input from '../components/Input/Input';
import { convertDigitToProperFormat } from '../utils/number';
import { smartDateString } from '../utils/date';
import LoadingCircleIndicator from '../components/LoadingCircleIndicator/LoadingCircleIndicator';
import { AdmitTagProfileMap } from './utils';
import Test from '../assets/images/homepage/Test.png';
import Corona from '../assets/images/homepage/Corona.png';
import CTScan from '../assets/images/homepage/CTScan.png';
import FAQ from '../assets/images/homepage/FAQ.png';
import Oxygen from '../assets/images/homepage/Oxygen.png';
import Vaccine from '../assets/images/homepage/Vaccine.png';
import { IProvider, ITags } from 'store/providers/providerTypes';
import { RootState } from 'store/store';

const firstImages = [
  { value: Corona, target: '/1/f/2504' },
  { value: Vaccine, target: '/1/f/2526' },
  { value: Oxygen, target: '/1/f/2553' },
];
const secondImages = [
  { value: FAQ, target: '/1/f/2544' },
  { value: Test, target: '/1/f/2503' },
  { value: CTScan, target: '/1/f/2529' },
];
interface IDispatchToProps {}

export type KeyValue = { [key: string]: number | [{ [key: string]: number }] };
interface IComponentStates {
  admitCapacityInfo?: KeyValue;
  admitFreeInfo?: KeyValue;
  admitFilledInfo?: KeyValue;
  outpatientCapacityInfo?: KeyValue;
  outpatientTotalCapacityInfo?: KeyValue;
  lastAdmitResponseTime?: number;
  outpatientFreeInfo?: KeyValue;
  tagName?: { [key: string]: string };
  tagGroup?: { [key: string]: string };
  baseOutpatientSortShift?: string;
  // admitOrder?: string[];
  loading: boolean;
  openAdmitDetail: boolean;
  openOutpatientDetail: boolean;
  searchText?: string;
  shifts?: string[];
  days?: number[];
  currentDay?: number;
  currentShiftIndex?: number;
  totalAdmit?: number;
}

interface IOwnProps {
  provider: IProvider;
}

interface IStateToProps {
  tags: ITags;
}

type IComponentProps = IDispatchToProps & IStateToProps & IOwnProps;

class AdmitInfo extends PureComponent<IComponentProps, IComponentStates> {
  state: IComponentStates = {
    loading: true,
    openAdmitDetail: false,
    openOutpatientDetail: false,
  };
  goTo = (e: any, path: string) => {
    e.preventDefault();
    navigate(path);
  };
  componentDidMount(): void {
    const { tags } = this.props;
    fetchEmptyCounts().then((result) => {
      const tagName: { [key: string]: string } = {};
      const tagGroup: { [key: string]: string } = {};
      [
        ...Object.keys(result.outpatientCapacityInfo),
        ...Object.keys(result.admitCapacityInfo),
      ].forEach((item: string) => {
        const tag = tags?.data[Number(item)];
        tagName[item] = tag?.text ?? '-';
        tagGroup[item] = tag?.parentId
          ? tags.data[tag.parentId].text!.toString()
          : '';
      });
      this.setState({ tagName, tagGroup, loading: false, ...result });
    });
  }
  render() {
    const {
      admitFreeInfo,
      admitFilledInfo,
      tagName,
      tagGroup,
      openAdmitDetail,
      openOutpatientDetail,
      searchText,
      admitCapacityInfo,
      outpatientFreeInfo,
      outpatientCapacityInfo,
      outpatientTotalCapacityInfo,
      baseOutpatientSortShift,
      lastAdmitResponseTime,
      totalAdmit,
    } = this.state;
    const { provider } = this.props;
    const admitOrder: undefined | string[] =
      admitFreeInfo &&
      Object.entries(admitFreeInfo)
        .sort((a, b) => {
          if (a[0] === 'total') return -1;
          else if (b[0] === 'total') return 1;
          return (b[1] as number) - (a[1] as number);
        })
        .map((x) => x[0]);
    const outpatientOrder =
      outpatientFreeInfo &&
      Object.entries(outpatientFreeInfo)
        .sort((a, b) => {
          if (a[0] === 'total') return -1;
          else if (b[0] === 'total') return 1;
          return (
            (b[1][baseOutpatientSortShift!] ?? -1) -
            (a[1][baseOutpatientSortShift!] ?? -1)
          );
        })
        .map((x) => x[0]);
    // const refDate =
    //   new Date().getHours() >= 15
    //     ? new Date().getTime()
    //     : new Date().getTime() - 24 * 60 * 60 * 1000;
    const totalBed =
      messages.totalBed + smartDateString(lastAdmitResponseTime || 0, true);
    const totalOutpatient = messages.totalOutpatientInShift + '';
    // shifts?.[currentShiftIndex!] +
    // ' - ' +
    // smartDateString(currentDay as any);
    return (
      <Container>
        {totalAdmit ? (
          <ICUContainer>
            <Row bold={true}>
              <ItemTitle>{messages.totalAdmit}</ItemTitle>
              <ItemValue>
                {convertDigitToProperFormat(totalAdmit!) + ' نفر'}
              </ItemValue>
            </Row>
          </ICUContainer>
        ) : null}
        <DownContainer>
          <BedContainer>
            {admitFreeInfo ? (
              <>
                <Row bold={true}>
                  <ItemTitle>{totalBed}</ItemTitle>
                  {/*<ItemValue>
                    {convertDigitToProperFormat(admitFreeInfo['total'] as number)}
                  </ItemValue>*/}
                </Row>
                {admitOrder!
                  .slice(1, Math.min(admitOrder!.length, 4))
                  .map((id) => {
                    return (
                      <Row key={id}>
                        <ItemTitle>
                          {AdmitTagProfileMap[id] ? (
                            <a
                              href={'/' + AdmitTagProfileMap[id]}
                              onClick={(event) => {
                                this.goTo(event, '/' + AdmitTagProfileMap[id]);
                              }}
                            >
                              {tagName![id]}
                            </a>
                          ) : (
                            tagName![id]
                          )}
                        </ItemTitle>
                        <ItemValue>
                          {convertDigitToProperFormat(
                            admitFreeInfo![id] as number
                          )}
                        </ItemValue>
                      </Row>
                    );
                  })}
                <Button
                  color="green"
                  style={{ width: '100%' }}
                  onClick={() => this.setState({ openAdmitDetail: true })}
                >
                  {messages.showAll}
                </Button>
              </>
            ) : (
              <LoadingCircleIndicator />
            )}
          </BedContainer>
          <BedContainer>
            {outpatientFreeInfo ? (
              <>
                <Row bold={true}>
                  <ItemTitle>{totalOutpatient}</ItemTitle>
                  {/*<ItemValue>
                    {convertDigitToProperFormat(outpatientFreeInfo['total'] as number)}
                  </ItemValue>*/}
                </Row>
                {outpatientOrder!
                  .slice(1, Math.min(outpatientOrder!.length, 4))
                  .map((id) => {
                    return (
                      <Row key={id}>
                        <ItemTitle>
                          {AdmitTagProfileMap[id] ? (
                            <a
                              href={'/' + AdmitTagProfileMap[id]}
                              onClick={(event) => {
                                this.goTo(event, '/' + AdmitTagProfileMap[id]);
                              }}
                            >
                              {tagName![id]}
                            </a>
                          ) : (
                            tagName![id]
                          )}
                        </ItemTitle>
                        <ItemValue>
                          {convertDigitToProperFormat(
                            outpatientFreeInfo![id]![baseOutpatientSortShift!]
                          )}
                        </ItemValue>
                      </Row>
                    );
                  })}
                <Button
                  color="green"
                  style={{ width: '100%' }}
                  onClick={() => this.setState({ openOutpatientDetail: true })}
                >
                  {messages.showAllWithShift}
                </Button>
              </>
            ) : (
              <LoadingCircleIndicator />
            )}
          </BedContainer>
        </DownContainer>
        <ImageSection>
          <ImageColumn>
            {firstImages.map((image, index) => {
              return (
                <ImageContainer
                  key={index}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    navigate(image.target);
                  }}
                >
                  <ImageComponent src={image.value} alt={'none'} />
                </ImageContainer>
              );
            })}
          </ImageColumn>
          <ImageColumn>
            {secondImages.map((image, index) => {
              return (
                <ImageContainer
                  key={index}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    navigate(image.target);
                  }}
                >
                  <ImageComponent src={image.value} alt={'none'} />
                </ImageContainer>
              );
            })}
          </ImageColumn>
          <ImageRow>
            {firstImages.concat(secondImages).map((image, index) => {
              return (
                <ImageContainer
                  key={index}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    navigate(image.target);
                  }}
                >
                  <ImageComponent src={image.value} alt={'none'} />
                </ImageContainer>
              );
            })}
          </ImageRow>
        </ImageSection>
        {provider.description && provider.description.length && (
          <Descriptoin>
            {provider.description}
            <span>{messages.more}</span>{' '}
          </Descriptoin>
        )}
        {admitFreeInfo && (
          <MyModal
            onClose={() =>
              this.setState({ openAdmitDetail: false, searchText: '' })
            }
            title={totalBed}
            // onClose={onClose}
            width={'60%'}
            isActive={openAdmitDetail}
            onSelectATab={() => {
              return 1 as any;
            }}
          >
            <Input
              id="searchText"
              type="text"
              value={searchText}
              onChange={(e) => {
                this.setState({ searchText: e.target.value });
              }}
              placeholder={messages.searchHospital}
              wrapperStyle={{ margin: '10px 5px 5px' }}
            />
            <TableWrapper>
              <table>
                <TableHead>
                  <TableHeaderRow>
                    <TableHeaderTitle>{messages.hospitalName}</TableHeaderTitle>
                    <TableHeaderTitleValue>
                      {messages.empty}
                    </TableHeaderTitleValue>
                    <TableHeaderTitleValue>
                      {messages.filled}
                    </TableHeaderTitleValue>
                    <TableHeaderTitleValue last>
                      {messages.capacity}
                    </TableHeaderTitleValue>
                  </TableHeaderRow>
                </TableHead>
                <tbody>
                  {admitOrder!.splice(1).map((id) => {
                    if (
                      !searchText ||
                      searchText.trim().length === 0 ||
                      tagName![id].includes(searchText)
                    )
                      return (
                        <TableRow key={id}>
                          <TableItemTitle>
                            {AdmitTagProfileMap[id] ? (
                              <a
                                href={'/' + AdmitTagProfileMap[id]}
                                onClick={(event) => {
                                  this.goTo(
                                    event,
                                    '/' + AdmitTagProfileMap[id]
                                  );
                                }}
                              >
                                {tagName![id]}
                              </a>
                            ) : (
                              tagName![id]
                            )}
                            <TableItemSubTitle>
                              {messages['type_' + tagGroup![id]]}
                              {messages['extra_' + tagName![id]]
                                ? ' - ' + messages['extra_' + tagName![id]]
                                : ''}
                            </TableItemSubTitle>
                          </TableItemTitle>
                          <TableItemValue>
                            {convertDigitToProperFormat(
                              admitFreeInfo![id] as number
                            )}
                          </TableItemValue>
                          <TableItemValue>
                            {convertDigitToProperFormat(
                              admitFilledInfo![id] as number
                            )}
                          </TableItemValue>
                          <TableItemValue>
                            {convertDigitToProperFormat(
                              admitCapacityInfo![id] as number
                            )}
                          </TableItemValue>
                        </TableRow>
                      );
                    else return <></>;
                  })}
                </tbody>
              </table>
            </TableWrapper>
          </MyModal>
        )}
        {outpatientFreeInfo && (
          <MyModal
            onClose={() =>
              this.setState({ openOutpatientDetail: false, searchText: '' })
            }
            title={messages.totalOutpatient}
            // onClose={onClose}
            width={'80%'}
            isActive={openOutpatientDetail}
            onSelectATab={() => {
              return 1 as any;
            }}
          >
            <>
              {/*<ModalTitle>{messages.totalOutpatient}</ModalTitle>*/}
              {/*<ModalDescriptoin>*/}
              {/*  {messages.descriptionOutpatient}*/}
              {/*</ModalDescriptoin>*/}
              <Input
                id="searchText"
                type="text"
                value={searchText}
                onChange={(e) => {
                  this.setState({ searchText: e.target.value });
                }}
                placeholder={messages.searchHospital}
                wrapperStyle={{ margin: '10px 5px 5px' }}
              />
              {/*<DaySelect>
                {days?.map((i) => {
                  return (
                    <div style={{ flexShrink: 0 }} key={i}>
                      <input
                        type="radio"
                        className="with-gap"
                        style={{
                          position: 'initial',
                          width: '1px',
                          height: '1px',
                        }}
                        value={i}
                        name={i.toString()}
                        onChange={(e) => {
                          this.setState({ currentDay: Number(e.target.value) });
                        }}
                        id={i.toString()}
                        checked={currentDay === i}
                      />
                      <label
                        className={styles.checkboxLabel}
                        htmlFor={i.toString()}
                      >
                        {smartDateString(i as any)}
                      </label>
                    </div>
                  );
                })}
              </DaySelect>*/}
              <TableWrapper>
                <table>
                  <TableHead>
                    <TableHeaderRow>
                      <TableHeaderTitle>
                        {messages.hospitalName}{' '}
                        <span style={{ left: 0, position: 'absolute' }}>
                          {/*  {messages.shift}*/}
                        </span>
                      </TableHeaderTitle>
                      {/*{shifts!.map((s, i) => {
                        if (
                          currentDay === days![0] &&
                          i < this.state.currentShiftIndex!
                        )
                          return <></>;
                        return (
                          <TableHeaderTitleValue key={s}>
                            <TableHeaderTitleValueText>
                              {s}
                            </TableHeaderTitleValueText>
                          </TableHeaderTitleValue>
                        );
                      })}*/}
                      <TableHeaderTitleValue last>
                        {messages.betCount}
                      </TableHeaderTitleValue>
                      <TableHeaderTitleValue last>
                        {messages.totalCapacity}
                      </TableHeaderTitleValue>
                    </TableHeaderRow>
                  </TableHead>
                  <tbody>
                    {outpatientOrder!.splice(1).map((id) => {
                      if (
                        !searchText ||
                        searchText.trim().length === 0 ||
                        tagName![id].includes(searchText)
                      )
                        return (
                          <TableRow key={id}>
                            <TableItemTitle>
                              {AdmitTagProfileMap[id] ? (
                                <a
                                  href={'/' + AdmitTagProfileMap[id]}
                                  onClick={(event) => {
                                    this.goTo(
                                      event,
                                      '/' + AdmitTagProfileMap[id]
                                    );
                                  }}
                                >
                                  {tagName![id]}
                                </a>
                              ) : (
                                tagName![id]
                              )}
                              <TableItemSubTitle>
                                {messages['type_' + tagGroup![id]]}
                                {messages['extra_' + tagName![id]]
                                  ? ' - ' + messages['extra_' + tagName![id]]
                                  : ''}
                              </TableItemSubTitle>
                            </TableItemTitle>
                            {/*{shifts!.map((s, i) => {
                              if (
                                currentDay === days![0] &&
                                i < this.state.currentShiftIndex!
                              )
                                return <></>;
                              return (
                                <TableItemValue key={s}>
                                  {convertDigitToProperFormat(
                                    outpatientFreeInfo![id][
                                      currentDay + '$$' + s
                                    ] as number
                                  )}
                                </TableItemValue>
                              );
                            })}*/}
                            <TableItemValue>
                              {convertDigitToProperFormat(
                                outpatientCapacityInfo![id] as number
                              )}
                            </TableItemValue>
                            <TableItemValue>
                              {convertDigitToProperFormat(
                                outpatientTotalCapacityInfo![id] as number
                              )}
                            </TableItemValue>
                          </TableRow>
                        );
                      else return <></>;
                    })}
                  </tbody>
                </table>
              </TableWrapper>
            </>
          </MyModal>
        )}
      </Container>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const tags = state.providers.tags[props.provider.id]!;
  return { tags };
};

export default connect(mapStateToProps, null)(AdmitInfo as any);
